// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#svgButterfly[data-v-9790c35a] {\n  fill: hsl(210, 86%, 57%);\n}\n.button:hover #svgButterfly[data-v-9790c35a] {\n  fill: white;\n}", ""]);
// Exports
module.exports = exports;
